// Guide scopes operate on already-authorised items only. Do not change the shared
// audio/essay partition or infer authorisation from an ID in a dropdown.
export function relatedPracticeId(item) {
    return item?.content?.relatedTextId || item?.relatedTextId || null;
}

export function guidePracticeItems(items, guides, guideId) {
    if (!guides.some(g => g.id === guideId)) return [];
    return items.filter(item => relatedPracticeId(item) === guideId);
}

export function textQuizItems(items, knownTextIds, guides, textId) {
    const guideIds = new Set(guides.map(g => g.id));
    return items.filter(item => {
        const linked = relatedPracticeId(item);
        // Preserve legacy unlinked/unknown-item fallback, but never mix visible
        // Guide questions into a set text's practice.
        return !guideIds.has(linked) && (!linked || linked === textId || !knownTextIds.has(linked));
    });
}

export function visibleGuide(guides, id) {
    return guides.find(g => g.id === id) || guides[0] || null;
}

// Sort numbered members within each named workshop series. Non-workshop guides
// keep their stored slots, so adding Q5 lessons does not displace the Q4 guide.
export function orderWorkshopGuides(guides) {
    const series = new Map();
    const identify = g => g.content?.title?.match(/^(.*?Comparison Workshop)\s+(\d+)\b/i);
    for (const g of guides) {
        const match = identify(g);
        if (!match) continue;
        const key = match[1].toLowerCase();
        if (!series.has(key)) series.set(key, []);
        series.get(key).push({ guide: g, number: Number(match[2]) });
    }
    for (const entries of series.values()) entries.sort((a, b) => a.number - b.number);
    return guides.map(g => {
        const match = identify(g);
        return match ? series.get(match[1].toLowerCase()).shift().guide : g;
    });
}

// URL-only selection; it never grants access. Readers still resolve IDs against
// already-authorised items. Preserve unrelated bookmark/notes query parameters.
export function guideReaderParams(current, patch) {
    const next = new URLSearchParams(current);
    for (const [key, value] of Object.entries(patch)) {
        if (value == null || value === '') next.delete(key);
        else next.set(key, value);
    }
    return next;
}

export function guideReaderView(params) {
    const view = params.get('view');
    return ['analysis', 'flashcards', 'quizzes', 'essays'].includes(view) ? view : 'analysis';
}
